(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-iot-data"]) return;
  try {
    
    let lastobjects = 0;
    let lastrequests = 0;
    let nimusobjects = 0;
    let nimusrequests = 0;
    let nowobjects = 0;
    let nowrequests = 0;
    let test123 = 0;
    let test5 = 0;

    function getdata() {
        $.ajax({
            url: '//api.ubibot.com/getOverallStats',
            type: 'GET',
            dataType: "json",
            cache: false,
            error: function () {
                //alert("请求失败");
            },
            success: function (data) {
              console.log(data.objects)
                if(test5 == 4){
                    test5 = 0;
                }
                if(test5 == 0){
                    if(nowobjects == 0){
                        nowobjects = 0.9 * data.objects;
                    }
                    lastobjects = nowobjects;
                    nimusobjects = (data.objects - nowobjects) / 300;
                    nowobjects = data.objects;
                }
                test5++;
                if(nowrequests == 0){
                    nowrequests = 0.9 * data.requests;
                }
                lastrequests = nowrequests;
                nimusrequests = (data.requests - nowrequests) / 60;
                nowrequests = data.requests;
                test123 = 0;

                //console.log(nimusobjects, nimusrequests);
              test();
            }
        });
    }

    function test(){
      show_num(parseInt(parseFloat(lastobjects) + (test5 * 60 + test123) * parseFloat(nimusobjects)));
      test123++;
    }

    function show_num(n) {
      console.log(n)
        // var it = $(".t_num i");
        // var len = String(n).length;
        // for (var i = 0; i < len; i++) {
        //     if (it.length <= i) {
        //         $(".t_num").append("<i></i>");
        //     }
        //     var num = String(n).charAt(i);
        //     var y = -parseInt(num) * 30;
        //     var obj = $(".t_num i").eq(i);
        //     obj.animate({
        //             backgroundPosition: '(0 ' + String(y) + 'px)'
        //         }, 'slow', 'swing', function () { }
        //     );
        // }
        $('.t_num').text(n);
        $(".t_num_text").text("条");
        $(".t_num_text").append("<sup>+</sup>");
        //$("#cur_num").val(n);
    }
    getdata();
    setInterval(getdata(), 60000);
    setInterval(test(), 3000);

  } catch(e) { console.error(e); }
})();
})();
